// src/services/estanqueService.js
import api from "./Api"; // 👈 respeta la A mayúscula del archivo

const EST = "/Estanques";

// Obtiene los estanques del usuario logueado
export const obtenerEstanques = async () => {
  const { data } = await api.cachedGet(`${EST}/mis-estanques`);
  return data;
};

// Crea un nuevo estanque (el backend toma el usuario del token)
export const crearEstanque = async ({ nombre, descripcion, permisos }) => {
  const { data } = await api.post(`${EST}/crear`, { nombre, descripcion, permisos });
  return data;
};

// Actualiza un estanque
export const actualizarEstanque = async (id, { nombre, descripcion, estaActivo, permisos }) => {
  const { data } = await api.put(`${EST}/actualizar/${id}`, {
    nombre,
    descripcion,
    estaActivo,
    permisos,
  });
  return data;
};

// Cambia el estado activo/inactivo de un estanque
export const cambiarEstadoEstanque = async (id, estaActivo) => {
  const endpoint = estaActivo ? `${EST}/activar/${id}` : `${EST}/eliminar/${id}`;
  const { data } = estaActivo ? await api.put(endpoint, {}) : await api.delete(endpoint);
  return data;
};

const estanqueService = {
  obtenerEstanques,
  crearEstanque,
  actualizarEstanque,
  cambiarEstadoEstanque,
};

export default estanqueService;
